// extracted by mini-css-extract-plugin
module.exports = {"main":"ProcessingOverlay_main__3xKvW","title":"ProcessingOverlay_title__2QFfm","detail":"ProcessingOverlay_detail__G_ZDt"};